import React, { useContext } from 'react';
import { BankUserContext } from '../../bankUserContext';
import { withContext } from './RoleAuthorizationClassComponent';


function RoleAuthorization(page:string,action:string,productId?:string) {
    const bankUserContext = useContext(BankUserContext);
   if(bankUserContext.bankRolesData?.claims){
    return withContext(bankUserContext,page,action,productId)
}

return false
}

export default RoleAuthorization;